/**
 * Text Animations using GSAP ScrollTrigger & GSAP SplitText
 */

export class TextAnimations {
  constructor() {
    this.init();
  }

  /**
   * Initialize animations
   */
  init() {
    if (
      typeof gsap === "undefined" ||
      typeof ScrollTrigger === "undefined" ||
      typeof SplitText === "undefined"
    ) {
      console.warn("GSAP or ScrollTrigger or SplitText not loaded");
      return;
    }

    gsap.registerPlugin(ScrollTrigger, SplitText);
    this.mm = gsap.matchMedia();

    this.fadeInTitles();
    this.fadeInDescriptions();
    this.scrollingTextAnimations();
  }

  /**
   * Fade in Title on scroll
   */
  fadeInTitles() {
    const titles = [...document.querySelectorAll("[data-title]")];
    if (!titles.length) return;

    this.mm.add("(min-width: 992px)", () => {
      titles.forEach((title) => {
        let titleSplitText;

        titleSplitText = new SplitText(title, {
          type: "words",
          wordsClass: "text-words",
        });

        const titleAnimTl = gsap.timeline({
          scrollTrigger: {
            trigger: title,
            start: "top 80%",
            end: "bottom 80%",
          },
        });

        titleAnimTl.fromTo(
          titleSplitText.words,
          {
            yPercent: 50,
            opacity: 0,
          },
          {
            duration: 0.75,
            opacity: 1,
            yPercent: 0,
            ease: "expo.out",
            stagger: 0.075,
          }
        );
      });
    });
  }

  /**
   * Fade in Description on scroll
   */
  fadeInDescriptions() {
    const descriptions = [...document.querySelectorAll("[data-description]")];
    if (!descriptions.length) return;

    this.mm.add("(min-width: 992px)", () => {
      descriptions.forEach((description) => {
        let descriptionSplitText;

        descriptionSplitText = new SplitText(description, {
          type: "words",
          wordsClass: "text-words",
        });

        gsap.fromTo(
          descriptionSplitText.words,
          {
            opacity: 0,
            yPercent: 101,
          },
          {
            scrollTrigger: {
              trigger: description,
              start: "top 75%",
              end: "bottom 75%",
            },
            opacity: 1,
            yPercent: 0,
            duration: 0.6,
            ease: "expo.out",
            stagger: 0.01,
          }
        );
      });
    });
  }

  /**
   * Infinite scrolling text animations
   */
  scrollingTextAnimations() {
    const section = document.querySelector(".wps-header-hero__wrapper");
    if (!section) return;
    const parentText = section.querySelector(".parent-text");
    if (!parentText) return;
    const texts = parentText.querySelectorAll(".rolling-texts .text");
    if (!texts.length) return;

    gsap.to(parentText, {
      y: 200,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });

    gsap.set(texts, {
      yPercent: 100,
      opacity: 0,
    });

    const tl = gsap.timeline({ repeat: -1 });

    const ENTER_DURATION = 0.5;
    const HOLD_DURATION = 1;
    const EXIT_DURATION = 0.5;

    texts.forEach((text, i) => {
      tl.to(text, {
        yPercent: 0,
        opacity: 1,
        duration: ENTER_DURATION,
        ease: "power3.out",
      });

      tl.to({}, { duration: HOLD_DURATION });

      tl.to(text, {
        yPercent: -100,
        opacity: 0,
        duration: EXIT_DURATION,
        ease: "power3.in",
      });
    });
  }
}
